<app-content-header i18n-title title="Generated Text - Destinations" i18n-subTitle
                    subTitle="Filter our AI generated destination texts"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>

<div class="content">

  <div class="row">
    <div class="col-md-3">

      <div class="block">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>
        <div class="block-content block-content-full">
          // No Filter
        </div>
      </div>

    </div>

    <div class="col-md-9">
      <div class="block" *ngIf="paginationData != null">
        <div class="block-header block-header-default">
         &nbsp;<button class="btn btn-sm btn-success" (click)="generatedTextDestinationAddModalComponent.showChildModal()" tooltip="Add a new entry"><i class="fa fa-plus"></i></button>
        </div>
        <div class="block-content block-content-full">
          <div class="table-responsive">
            <table class="table table-striped table-vcenter">
              <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Identifier</th>
                <th class="text-left">Pattern</th>
                <th class="text-left">State</th>
                <th class="text-left">Enabled</th>
                <th class="text-center">Actions</th>
              </tr>
              </thead>
              <tr
                *ngFor="let element of elements | paginate: {
              itemsPerPage: paginationData.limit,
              currentPage: paginationData.page,
              totalItems: paginationData.total}"
              >
                <td class="text-left">
                  {{element._id}}
                </td>
                <td class="text-left">
                  {{element.identifier}}
                </td>
                <td class="text-left">
                  {{element.patternId}}
                </td>
                <td class="text-left">
                  {{element.state}}
                </td>
                <td class="text-left">
                  {{element.enabled}}
                </td>
                <td class="text-center">
                  <div class="btn-group">
                    <a class="btn btn-sm btn-primary" [routerLink]="['/pages/generated-text/destination/', element._id]"><i
                      class="fa fa-pencil"></i></a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="block-content block-content-full block-content-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
          ></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<app-generated-text-destination-add-modal
#generatedTextDestinationAddModalComponent></app-generated-text-destination-add-modal>
